module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_monsen_sm-b50a0190914c92c90872864af34a9a96.png";